export class DesignEmailTemplate {
    id: number;
    workflowId: number;
    subject: string;
    body: string;
    jsonContent: string;
    mailTemplateType: number;
    createAt: string;
    active: boolean;
    deleted: boolean;
}
